import { Filter } from '../services/types/services'
import { createProductsSlice } from './slices/products'
import { createContextSlice } from './slices/context'
import { ClearFiltersProps, createFiltersSlice } from './slices/filters'
import { createSharedSlice } from './slices/shared'
import { QueryProductsProps } from './slices/products/types'
import { ApplyRangeFilterProps } from './slices/filters/types'

export type SearchStoreState = ReturnType<typeof createContextSlice> &
  ReturnType<typeof createFiltersSlice> &
  ReturnType<typeof createProductsSlice> &
  ReturnType<typeof createSharedSlice>

export enum TrackingActionsEnum {
  toggleFiltersMenu = 'toggleFiltersMenu',
  toggleFiltersCategory = 'toggleFiltersCategory',
  clearFilters = 'clearFilters',
  sortBy = 'sortBy',
  queryProducts = 'queryProducts',
  loadMoreProducts = 'loadMoreProducts',
  changeDepartment = 'changeDepartment',
  applyRangeFilter = 'applyRangeFilter',
}

export type TrackingActionTypes = keyof typeof TrackingActionsEnum

export type TrackingPayload =
  | Filter[]
  | string[]
  | ClearFiltersProps[]
  | QueryProductsProps[]
  | boolean[]
  | ApplyRangeFilterProps[]

export type StoreProviderProps = {
  initialState?: Partial<SearchStoreState>
}
